import { render, staticRenderFns } from "./area-stack.md?vue&type=template&id=11191f08&"
import script from "./area-stack.md?vue&type=script&lang=js&"
export * from "./area-stack.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11191f08')) {
      api.createRecord('11191f08', component.options)
    } else {
      api.reload('11191f08', component.options)
    }
    module.hot.accept("./area-stack.md?vue&type=template&id=11191f08&", function () {
      api.rerender('11191f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Area/area-stack.md"
export default component.exports